import React from "react";

const IconDistribution: React.FC = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 70"
      stroke="currentColor"
      strokeWidth={6}
    >
      <path
        className="cls-1"
        d="m3,68.71C29.89,68.71,29.89,3,56.79,3"
      />
      <line
        className="cls-2"
        x1="25.87"
        y1="66.68"
        x2="46.77"
        y2="66.68"
      />
      <line
        className="cls-2"
        x1="34.97"
        y1="53.6"
        x2="55.87"
        y2="53.6"
      />
      <line
        className="cls-2"
        x1="40.63"
        y1="40.52"
        x2="61.53"
        y2="40.52"
      />
      <line
        className="cls-2"
        x1="46.08"
        y1="27.46"
        x2="67.28"
        y2="27.46"
      />
      <line
        className="cls-2"
        x1="54.41"
        y1="14.36"
        x2="75.61"
        y2="14.36"
      />
    </svg>
  );
};

export default IconDistribution;
